export default class EspDiConsts {
    static get owningContainer() {
        return 'EspDi_OwningContainer';
    }
}